enum DisplayNames {
  ResponsiveLayout = 'ResponsiveLayout',
  ResponsiveLayoutRightContent = 'ResponsiveLayoutRightContent',
  ResponsiveLayoutLeftContent = 'ResponsiveLayoutLeftContent',
  ResponsiveTwoColumnLayout = 'ResponsiveTwoColumnLayout',
  ResponsiveLayoutMainContent = 'ResponsiveLayoutMainContent'
}

export default DisplayNames;
